import { render, staticRenderFns } from "./pc-chat.vue?vue&type=template&id=2840ff67&scoped=true&"
import script from "./pc-chat.vue?vue&type=script&lang=js&"
export * from "./pc-chat.vue?vue&type=script&lang=js&"
import style0 from "./pc-chat.vue?vue&type=style&index=0&id=2840ff67&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2840ff67",
  null
  
)

export default component.exports